import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=5a28f6b2&"
import script from "./Start.vue?vue&type=script&lang=ts&"
export * from "./Start.vue?vue&type=script&lang=ts&"
import style0 from "./Start.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logotype: require('/Users/markussh/git/theodora-tech-website/src/components/misc/Logotype.vue').default,SectionStartHeadingDesktop: require('/Users/markussh/git/theodora-tech-website/src/components/section/Start/HeadingDesktop.vue').default,SectionStartHeadingMobile: require('/Users/markussh/git/theodora-tech-website/src/components/section/Start/HeadingMobile.vue').default})
